import { render } from "./LeadsPage.vue?vue&type=template&id=a09bbcec&ts=true"
import script from "./LeadsPage.vue?vue&type=script&lang=ts"
export * from "./LeadsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__